module.exports = __webpack_public_path__ + "static/media/invoice.4844feb7.svg";